import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Media } from '../bulma';
import { withDesign } from '../Context';
import DivOrHtml from '../components/DivOrHtml';
import { setColorAlpha } from '../utils/colorsUtils';
import { WorkshopDate } from './templates/components';
import { FAIcon } from '../components';
import i18n from '../i18n/i18n';

class WorkshopDetailsModal extends PureComponent {
  render() {
    const { isActive, title, description, onClose, design, workshop, dateFormat } = this.props;
    const { primaryColor } = design;
    const { speakers = [], startDate, endDate, location, subCategory } = workshop;
    return (
      <Modal
        isActive={isActive}
        title={title}
        onClose={onClose}
        styles={{
          cardStyle: { width: '60%' },
          headStyle: { backgroundColor: primaryColor, color: 'white' },
          titleStyle: { fontSize: '1.1em', fontWeight: 'bold', color: 'white' },
        }}
        confirmBtn={{
          icon: 'edit',
          label: i18n.t('site.workshops.register'),
          style: {
            backgroundColor: setColorAlpha(primaryColor, 0.1),
            color: primaryColor,
            border: `1px solid ${setColorAlpha(primaryColor, 0.5)}`,
          },
        }}
      >
        <WorkshopDate startDate={startDate} endDate={endDate} format={dateFormat} />
        {location && (
          <div className="location">
            <FAIcon icon="map-marker-alt" /> {location}
          </div>
        )}
        {subCategory && (
          <div className="subCategory">
            <FAIcon icon="tag" /> {subCategory}
          </div>
        )}
        <DivOrHtml content={description} />
        <div style={{ marginTop: 10 }}>
          {speakers.map((speaker) => {
            const { _id, firstName, lastName, role, company, thumbnail } = speaker;
            return (
              <Media
                key={_id}
                imageLeft={thumbnail}
                imageProps={{ format: 'is-48x48', borderRadius: 'rounded' }}
                title={`${firstName} ${lastName}`}
                subtitle={`${role || ''} \n${company || ''}`}
              />
            );
          })}
        </div>
      </Modal>
    );
  }
}

WorkshopDetailsModal.defaultProps = {
  isActive: undefined,
  description: '',
  title: '',
};

WorkshopDetailsModal.propTypes = {
  design: PropTypes.object.isRequired,
  description: PropTypes.string,
  isActive: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  workshop: PropTypes.object.isRequired,
  dateFormat: PropTypes.string.isRequired,
};

export default withDesign(WorkshopDetailsModal);
